var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68398 16.25H6.75065C6.23398 16.25 5.77565 16.2333 5.36732 16.175C3.17565 15.9333 2.58398 14.9 2.58398 12.0833V7.91667C2.58398 5.1 3.17565 4.06667 5.36732 3.825C5.77565 3.76667 6.23398 3.75 6.75065 3.75H9.63398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0176 3.75H14.2509C14.7676 3.75 15.2259 3.76667 15.6342 3.825C17.8259 4.06667 18.4176 5.1 18.4176 7.91667V12.0833C18.4176 14.9 17.8259 15.9333 15.6342 16.175C15.2259 16.2333 14.7676 16.25 14.2509 16.25H13.0176",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.66699V18.3337",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74607 9.99967H9.75356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41209 9.99967H6.41957",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCheck2);
export default __webpack_public_path__ + "static/media/password-check2.5ed7f8886cd763336b4f5c0f2c4a9a53.svg";
export { ForwardRef as ReactComponent };